import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import { Button } from '@teuteuf-games/button';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { trackEvent } from '../../utils/analytics';
import { ItemModalShell } from './ItemModalShell';
import { MatchModeConfig } from './matchConfig';

/**
 * What someone sees when they open a shared link such as
 * /city-flags#img-420 or /emblems#emb-gb: the image their friend sent, the
 * question, and a way into the game. The answer is never named — working it
 * out is the whole point of the link.
 */
export const SharedItemModal = ({
  config,
  itemId,
  onClose,
}: {
  config: MatchModeConfig;
  itemId: string;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const i18nBase = config.i18nBase;

  const eventParams = {
    mode: config.key,
    content_type: `flagle_${config.key}_item`,
    item_id: `${config.key}-${itemId}`,
  };

  useEffect(() => {
    trackEvent('mode_shared_item_open', eventParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId]);

  const play = () => {
    trackEvent('mode_shared_item_play', eventParams);
    onClose();
  };

  return (
    <ItemModalShell
      config={config}
      open
      onClose={onClose}
      flagUrl={config.imageUrlForId(itemId)}
      // A bad id in the fragment should not leave a broken image on screen.
      onImageError={onClose}
    >
      <p className="text-center font-bold">{t(`${i18nBase}.share-question`)}</p>
      <Button
        buttonStyle="primary"
        label={t(`${i18nBase}.play-now`)}
        width="w-full"
        leadingIcon={<PlayArrowRoundedIcon />}
        onClick={play}
      />
    </ItemModalShell>
  );
};
